<template>
  <v-layout row wrap style="flex: 1 0; overflow: auto; align-items: flex-start">
    <v-flex xs6 class="inline-block px-4">
      <v-text-field hide-details :label="$t('Admin.MesureType.Form.Key')" v-model="met_key" />
      <v-text-field hide-details :label="$t('Admin.MesureType.Form.Libelle')" v-model="met_libelle" />
      <v-autocomplete
        hide-details
        :items="mesureUnites"
        :item-text="
          it => {
            return `${it.MUT_LIBELLE} (${it.MUT_SYMBOL})`
          }
        "
        item-value="MUT_ID"
        :label="$t('Admin.MesureType.Form.Unit')"
        v-model="mut_id"
      ></v-autocomplete>
      <v-autocomplete
        hide-details
        :items="umbTypes"
        item-text="UMT_LIBELLE"
        item-value="UMT_ID"
        :label="$t('Admin.MesureType.Form.UmbType')"
        v-model="umt_id"
      ></v-autocomplete>
      <v-text-field hide-details :label="$t('Admin.MesureType.Form.RegEx')" v-model="met_dataname_rx" />
      <v-checkbox
        hide-details
        v-model="met_is_calc"
        :label="`${$t('Admin.MesureType.Form.IsCalc')} : ${met_is_calc ? $t('Global.true') : $t('Global.false')}`"
      ></v-checkbox>
      <div class="mt-2">{{ $t('Admin.MesureType.Form.OffsetInfos') }}</div>
      <v-autocomplete
        hide-details
        :items="metValues"
        item-text="libelle"
        item-value="value"
        :label="$t('Admin.MesureType.Form.Offset')"
        v-model="met_exp_offset"
      ></v-autocomplete>
    </v-flex>
    <v-flex xs6 class="inline-block px-4">
      <v-card>
        <v-card-title class="pb-0">
          {{ $t('Admin.MesureType.Form.ConfigGraphDisplay') }}
          <v-spacer />
          <v-btn icon @click="resetConfigDisplay" :title="$t('Admin.MesureType.Form.ResetConfigGraphDisplay')">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-0">
          <v-checkbox
            hide-details
            v-model="gr_autoPlot"
            :label="`${$t('Admin.MesureType.Form.AutoPlot')} : ${gr_autoPlot ? $t('Global.true') : $t('Global.false')}`"
          ></v-checkbox>
          <v-checkbox
            hide-details
            v-model="gr_invertedYAxis"
            :label="`${$t('Admin.MesureType.Form.InvertedYAxis')} : ${
              gr_invertedYAxis ? $t('Global.true') : $t('Global.false')
            }`"
          ></v-checkbox>
          <v-checkbox
            hide-details
            v-model="gr_logarithmeAxis"
            :label="`${$t('Admin.MesureType.Form.LogarithmeAxis')} : ${
              gr_logarithmeAxis ? $t('Global.true') : $t('Global.false')
            }`"
          ></v-checkbox>
          <v-checkbox
            hide-details
            v-model="gr_forceDomain"
            :label="`${$t('Admin.MesureType.Form.ForceDomain')} : ${
              gr_forceDomain ? $t('Global.true') : $t('Global.false')
            }`"
          ></v-checkbox>
          <number-field-factor
            v-if="gr_forceDomain"
            hide-details
            dense
            v-model.number="gr_minDomain"
            :label="$t('Admin.MesureType.Form.MinDomain')"
          />
          <number-field-factor
            v-if="gr_forceDomain"
            hide-details
            dense
            v-model.number="gr_maxDomain"
            :label="$t('Admin.MesureType.Form.MaxDomain')"
          />
          <color-picker :label="$t('Admin.MesureType.Form.Color')" v-model="gr_colors" />
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script lang="ts">
import ColorPicker from '@/components/shared/ColorPicker.vue'
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  name: 'AdminMesureTypeForm',
  components: { ColorPicker },
})
export default class AdminMesureTypeForm extends Vue {
  created() {
    this.$store.myActions.MESUREUNITE_ENSURE_LIST()
    this.$store.myActions.UMBTYPE_ENSURE_LIST()
  }

  grDefaultConfig() {
    return {
      autoPlot: true,
      colors: ['#ec7404'],
      invertedYAxis: false,
    }
  }

  get metValues() {
    return [
      ...Array.from({ length: 49 }, (v, k) => k - 24).map(v => {
        return { value: v == 0 ? null : v, libelle: v }
      }),
    ]
  }

  get mesureUnites() {
    return this.$store.myGetters.mesureUnites
  }

  get umbTypes() {
    return this.$store.myGetters.umbTypes
  }

  get unite() {
    return this.$store.myGetters.mesureUnites
  }

  get modified() {
    return this.$store.myGetters.modifiedAdmMesureType
  }

  get met_key() {
    return this.modified.MET_KEY!
  }
  set met_key(value: string) {
    this.$store.myActions.MESURETYPE_UPDATE_MODIFIED_ADM({
      MET_KEY: value,
    })
  }

  get met_libelle() {
    return this.modified.MET_LIBELLE!
  }
  set met_libelle(value: string) {
    this.$store.myActions.MESURETYPE_UPDATE_MODIFIED_ADM({
      MET_LIBELLE: value,
    })
  }

  get mut_id() {
    return this.modified.MUT_ID!
  }
  set mut_id(value: number) {
    this.$store.myActions.MESURETYPE_UPDATE_MODIFIED_ADM({
      MUT_ID: value,
    })
  }

  get umt_id() {
    return this.modified.UMT_ID!
  }
  set umt_id(value: number) {
    this.$store.myActions.MESURETYPE_UPDATE_MODIFIED_ADM({
      UMT_ID: value,
    })
  }

  get met_dataname_rx() {
    return this.modified.MET_DATANAME_RX!
  }
  set met_dataname_rx(value: string) {
    this.$store.myActions.MESURETYPE_UPDATE_MODIFIED_ADM({
      MET_DATANAME_RX: value,
    })
  }

  get met_is_calc() {
    return this.modified.MET_IS_CALC! || false
  }
  set met_is_calc(value: boolean) {
    this.$store.myActions.MESURETYPE_UPDATE_MODIFIED_ADM({
      MET_IS_CALC: value,
    })
  }

  get met_exp_offset() {
    return this.modified.MET_EXP_OFFSET! == 0 ? null : this.modified.MET_EXP_OFFSET
  }
  set met_exp_offset(value: number | null) {
    this.$store.myActions.MESURETYPE_UPDATE_MODIFIED_ADM({
      MET_EXP_OFFSET: value,
    })
  }

  get met_config_json() {
    return this.modified.MET_CONFIG_JSON
  }
  set met_config_json(value: string | null) {
    this.$store.myActions.MESURETYPE_UPDATE_MODIFIED_ADM({
      MET_CONFIG_JSON: value,
    })
  }

  get gr_config_json() {
    return this.met_config_json ? JSON.parse(this.met_config_json) : this.grDefaultConfig()
  }

  get gr_autoPlot() {
    return this.gr_config_json.autoPlot
  }

  set gr_autoPlot(newValue: Boolean) {
    this.met_config_json = JSON.stringify({ ...this.gr_config_json, autoPlot: newValue })
  }

  get gr_invertedYAxis() {
    return this.gr_config_json.invertedYAxis
  }

  set gr_invertedYAxis(newValue: Boolean) {
    this.met_config_json = JSON.stringify({ ...this.gr_config_json, invertedYAxis: newValue })
  }

  get gr_logarithmeAxis() {
    return this.gr_config_json.logarithmeAxis
  }

  set gr_logarithmeAxis(newValue: Boolean) {
    this.met_config_json = JSON.stringify({ ...this.gr_config_json, logarithmeAxis: newValue })
  }

  get gr_forceDomain() {
    return this.gr_config_json.forceDomain
  }

  set gr_forceDomain(newValue: Boolean) {
    this.met_config_json = JSON.stringify({ ...this.gr_config_json, forceDomain: newValue })
  }

  get gr_minDomain() {
    return this.gr_config_json.minDomain
  }

  set gr_minDomain(newValue: number) {
    this.met_config_json = JSON.stringify({ ...this.gr_config_json, minDomain: newValue })
  }

  get gr_maxDomain() {
    return this.gr_config_json.maxDomain
  }

  set gr_maxDomain(newValue: number) {
    this.met_config_json = JSON.stringify({ ...this.gr_config_json, maxDomain: newValue })
  }

  get gr_colors() {
    return this.gr_config_json.colors[0]
  }

  set gr_colors(newValue: string) {
    this.met_config_json = JSON.stringify({ ...this.gr_config_json, colors: [newValue] })
  }

  resetConfigDisplay() {
    this.met_config_json = JSON.stringify({ ...this.gr_config_json, ...this.grDefaultConfig() })
  }
}
</script>
